import { render, staticRenderFns } from "./informationSetting.vue?vue&type=template&id=1473e846&scoped=true"
import script from "./informationSetting.vue?vue&type=script&lang=js"
export * from "./informationSetting.vue?vue&type=script&lang=js"
import style0 from "./informationSetting.vue?vue&type=style&index=0&id=1473e846&prod&lang=scss"
import style1 from "./informationSetting.vue?vue&type=style&index=1&id=1473e846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1473e846",
  null
  
)

export default component.exports